import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * En una SPA el navegador conserva la posición de scroll al cambiar de ruta:
 * ir del footer a una página legal la abre a media altura. Esto la lleva
 * arriba, salvo cuando la URL trae un ancla (`/#planes`), donde el navegador
 * ya hace lo correcto.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
